import React from "react";

import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import Title from "../../../components/Title";
import Text from "../../../components/Text";
import { Link } from "react-router-dom";

import style from "./style.module.css";

export default function ExceptionScreen({ onClick = () => { } }) {
    return (
        <>
            <Header />
            <div className="contents">
                <div className={style.form}>
                    <div className={style.formWrapper}>
                        <div className={style.messageContainer}>
                            <div className={`${style.formWrapperCenter}`}>
                                <div className={style.formRow}>
                                    <div className={style.formHeader}>
                                        <div className={style.formTitleWrapper}>
                                            <Title align={"center"} className={style.formTitle} tag={"h3"}>{"OOPS"}</Title>
                                        </div>
                                        <div className={style.formDescription}>
                                            <Text text={"Unexpected error! Please try again or contact support for assistance."} />
                                        </div>
                                    </div>
                                </div>
                                <div className={style.formRow}>
                                    <Link className={style.link} onClick={onClick} to={"/home"}>{"Go to Home"}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}